import { TemplateRef } from '@angular/core';

import { BehaviorSubject, Observable, tap } from 'rxjs';

import { Party } from '@shared/party/models';
import { IParams, SharedTableColumn, SharedTableDataSource, SharedTableItemType } from '@tablesready/common-ui';
import { TogoPartyService } from '../services';

export class TogoDataSource implements SharedTableDataSource<Party> {
  page: number;
  pageSize: number;
  maxDisplayPages: number;
  total: number;
  count$ = new BehaviorSubject(0);

  constructor(private readonly service: TogoPartyService) {}

  loadData(params: IParams): Observable<Party[]> {
    return this.service.getToGo({
      ...params,
      limit: 40 as any,
    })
      .pipe(tap((data) => {
        this.total = data.length;
        this.count$.next(this.total);
      }));
  }
}

export const TOGO_COLUMNS = (
  nameColumn: TemplateRef<unknown>,
  notifyColumn: TemplateRef<unknown>,
  actionsColumn: TemplateRef<unknown>,
  quotedTimeColumn: TemplateRef<unknown>,
  waitColumn: TemplateRef<unknown>,
): SharedTableColumn[] => ([
  {
    key: 'name',
    title: 'Party',
    dataType: SharedTableItemType.custom,
    cellTemplateRef: nameColumn,
    isSortable: true,
  },
  {
    key: 'quotedTime',
    title: 'Quoted time',
    dataType: SharedTableItemType.custom,
    cellTemplateRef: quotedTimeColumn,
    isSortable: true,
  },
  {
    key: 'wait',
    title: 'Wait',
    dataType: SharedTableItemType.custom,
    cellTemplateRef: waitColumn,
    isSortable: true,
  },
  {
    key: 'note',
    title: 'Notes',
    dataType: SharedTableItemType.string,
  },
  {
    key: 'notify',
    title: 'Notify',
    dataType: SharedTableItemType.custom,
    cellTemplateRef: notifyColumn,
  },
  {
    key: 'actions',
    title: 'Actions',
    dataType: SharedTableItemType.custom,
    cellTemplateRef: actionsColumn,
  },
]);
